import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Cormorant_Garamond, Nanum_Myeongjo, Host_Grotesk, Inter } from 'next/font/google'

const heading = Host_Grotesk({
    subsets: ['latin']
})

const body = Inter({
    subsets: ['latin']
})

const serif = Cormorant_Garamond({
    subsets: ['latin']
})

const display = Nanum_Myeongjo({
    subsets: ['latin'],
    weight: ['400', '700', '800']
})

const monoStack = 'ui-monospace, SFMono-Regular, Menlo, monospace'

const fontVariables = `:root{--font-app-sans:${heading.style.fontFamily};--font-app-heading:${heading.style.fontFamily};--font-app-body:${body.style.fontFamily};--font-app-serif:${serif.style.fontFamily};--font-app-mono:${monoStack};--font-app-display:${display.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <Component {...pageProps} />
        </div>
    )
}

export default App
